import styled from 'styled-components';
import FormHeading from './FormHeading';

const FormSubHeading = styled(FormHeading)`
    margin-top: 15px;
    color: ${props => props.theme.forms.subheader};
    font-size: 15px;
    text-transform: uppercase;
    font-weight: normal;
`;

export default FormSubHeading;



// WEBPACK FOOTER //
// ./src/components/atoms/form/FormSubHeading.js